"use client";

import React from "react";
import ImageWrapper from "./ImageWrapper";

interface FAQItemProps {
  question: string;
  answer: string;
  index: number;
  isOpen: boolean;
  onToggle: () => void;
  expendTrackingClass?: string;
  collapseTrackingClass?: string;
}

const FAQItem: React.FC<FAQItemProps> = ({
  question,
  answer,
  index,
  isOpen,
  onToggle,
  expendTrackingClass = '',
  collapseTrackingClass = ''
}) => {
  const contentId = `faq-answer-${index}`;
  const headerId = `faq-header-${index}`;

  return (
    <div className="rounded-md border border-[#E5E7EB] mb-3 md:mb-[24px]">
      {/* Header */}
      <button
        type="button"
        id={headerId}
        onClick={onToggle}
        aria-expanded={isOpen ? "true" : "false"}
        aria-controls={contentId}
        className={`group w-full flex justify-between items-baseline py-[12px] px-[17px]
                   md:py-[23px] md:px-[25px] cursor-pointer transition-colors 
                   hover:text-automotive-red text-left ${isOpen? expendTrackingClass : collapseTrackingClass}`}
      >
        <h3
          className="font-roboto font-semibold text-[13px] leading-[24px]
                     md:font-medium md:text-[16px] md:leading-[28px] md:text-[#111827]
                     flex-1 pr-3"
        >
          {question}
        </h3>

        <div
          className={`transition-transform duration-300 my-1 flex-shrink-0 ${
            isOpen ? "rotate-180" : ""
          }`}
        >
          <ImageWrapper
            src="/faq-drop-arrow.svg"
            alt="Toggle FAQ icon"
            width={12}
            height={12}
            cdnBaseUrl={process.env.NEXT_PUBLIC_CDN_STATIC_URL}
            title="Toggle FAQ"
          />
        </div>
      </button>

      {/* Answer */}
      <div
        id={contentId}
        role="region"
        aria-labelledby={headerId}
        aria-hidden={!isOpen}
        className={`overflow-hidden transition-all duration-300 ${
          isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div
          className="px-[17px] md:px-[25px] pb-[23px] font-roboto font-normal text-[12px] leading-[20px] text-[#4B5563]
                     md:text-[14px] md:leading-[24px]"
          dangerouslySetInnerHTML={{ __html: answer }}
        />
        
      </div>
    </div>
  );
};

export default FAQItem;
